import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import SliderProduct from '../Home/SliderProduct';
import Loading from '../Loading/Loading';

const CategoriesProducts = () => {
    const { categoryId } = useParams()

    // console.log(categoryId)


    const { data, isLoading } = useQuery(['categories', categoryId], () => fetch(`${process.env.REACT_APP_SECRET_API}/product?include=category,media&filter[category_id]=${categoryId}`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )
    
    if (isLoading) {
        return <Loading></Loading>
    }
    const latestProducts = data?.data

    const products =  latestProducts?.map(product => ({ ...product, quantity: 1 }))
    
    return (
        <div>
            <div className="container py-24 overflow-hidden">
                <div className='flex justify-between items-baseline'>
                </div>
                {/* gird system */}
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-6">

                    {products.length ? products.map((product) => (
                        <SliderProduct product={product} key={product.id}></SliderProduct>
                    )): (<div className='p-5'>
                    <p className='text-red-500 font-semibold lg:text-xl sm:text-lg'>Category is empty!</p>
                </div>)}
                </div>
            </div>
        </div>
    );
};

export default CategoriesProducts;